<template>
  <div>
    <v-text-field
      v-show="false"
      :name="name"
      :value="selectedStep"
    ></v-text-field>
    <svg
      :width="diagramWidth"
      :height="diagramHeight"
      viewBox="0 0 1400 250"
      class="workflow-svg"
    >
      <!-- Define arrow markers -->
      <defs>
        <marker
          id="arrowhead"
          markerWidth="8"
          markerHeight="6"
          refX="7"
          refY="3"
          orient="auto"
        >
          <polygon
            points="0 0, 8 3, 0 6"
            fill="#000000"
          />
        </marker>
        <marker
          id="arrowhead-back"
          markerWidth="8"
          markerHeight="6"
          refX="1"
          refY="3"
          orient="auto"
        >
          <polygon
            points="8 0, 0 3, 8 6"
            fill="#000000"
          />
        </marker>
      </defs>

      <!-- Forward arrows -->
      <line
        x1="110"
        y1="125"
        x2="200"
        y2="125"
        stroke="#000000"
        stroke-width="2"
        marker-end="url(#arrowhead)"
        class="arrow forward-arrow"
      />
      <line
        x1="360"
        y1="125"
        x2="400"
        y2="125"
        stroke="#000000"
        stroke-width="2"
        marker-end="url(#arrowhead)"
        class="arrow forward-arrow"
      />
      <line
        x1="560"
        y1="125"
        x2="610"
        y2="125"
        stroke="#000000"
        stroke-width="2"
        marker-end="url(#arrowhead)"
        class="arrow forward-arrow"
      />
      <line
        x1="750"
        y1="125"
        x2="800"
        y2="125"
        stroke="#000000"
        stroke-width="2"
        marker-end="url(#arrowhead)"
        class="arrow forward-arrow"
      />
      <line
        x1="960"
        y1="125"
        x2="1010"
        y2="125"
        stroke="#000000"
        stroke-width="2"
        marker-end="url(#arrowhead)"
        class="arrow forward-arrow"
      />
      <line
        x1="1150"
        y1="125"
        x2="1270"
        y2="125"
        stroke="#000000"
        stroke-width="2"
        marker-end="url(#arrowhead)"
        class="arrow forward-arrow"
      />

      <!-- Backward arrows from polygons to previous boxes with squared paths -->
      <path
        d="M 680 85 L 680 40 L 480 40 L 480 70"
        stroke="#000000"
        stroke-width="2"
        fill="none"
        marker-end="url(#arrowhead)"
        class="arrow backward-arrow"
      />
      <path
        d="M 1080 85 L 1080 40 L 880 40 L 880 70"
        stroke="#000000"
        stroke-width="2"
        fill="none"
        marker-end="url(#arrowhead)"
        class="arrow backward-arrow"
      />

      <!-- Beginning Circle -->
      <circle
        cx="80"
        cy="125"
        r="25"
        :fill="currentStep === 0 ? '#e0e0e0' : '#ffffff'"
        stroke="#666666"
        stroke-width="2"
        class="workflow-element clickable"
        @click="handleClick(0)"
      />
      <text
        x="80"
        y="180"
        text-anchor="middle"
        fill="#000000"
        font-size="22"
        font-weight="bold"
        class="element-text"
        @click="handleClick(0)"
      >
        {{ $t('beginning') }}
      </text>

      <!-- Initial Setup Box -->
      <rect
        x="210"
        y="75"
        width="140"
        height="100"
        rx="15"
        ry="15"
        :fill="currentStep === 1 ? '#e0e0e0' : '#ffffff'"
        stroke="#666666"
        stroke-width="2"
        class="workflow-element clickable"
        @click="handleClick(1)"
      />
      <text
        x="280"
        y="120"
        text-anchor="middle"
        fill="#000000"
        font-size="26"
        font-weight="bold"
        class="element-text"
        @click="handleClick(1)"
      >
        {{ $t('traffic') }}
      </text>
      <text
        x="280"
        y="150"
        text-anchor="middle"
        fill="#000000"
        font-size="22"
        class="element-text"
        @click="handleClick(1)"
      >
        {{ $t('hour_range', {s: 2, e: 4}) }}
      </text>

      <!-- Task 1 Box -->
      <rect
        x="410"
        y="75"
        width="140"
        height="100"
        rx="15"
        ry="15"
        :fill="currentStep === 2 ? '#e0e0e0' : '#ffffff'"
        stroke="#666666"
        stroke-width="2"
        class="workflow-element clickable"
        @click="handleClick(2)"
      />
      <text
        x="480"
        y="120"
        text-anchor="middle"
        fill="#000000"
        font-size="26"
        font-weight="bold"
        class="element-text"
        @click="handleClick(2)"
      >
        {{ $t('creation') }}
      </text>
      <text
        x="480"
        y="150"
        text-anchor="middle"
        fill="#000000"
        font-size="22"
        class="element-text"
        @click="handleClick(2)"
      >
        {{ $t('hour_range', {s: 8, e: 16}) }}
      </text>

      <!-- Decision 1 Diamond -->
      <polygon
        points="680,75 740,125 680,175 620,125"
        :fill="currentStep === 3 ? '#e0e0e0' : '#ffffff'"
        stroke="#666666"
        stroke-width="2"
        class="workflow-element clickable"
        @click="handleClick(3)"
      />
      <text
        x="680"
        y="120"
        text-anchor="middle"
        fill="#000000"
        font-size="20"
        font-weight="bold"
        class="element-text"
        @click="handleClick(3)"
      >
        {{ $t('approval') }}
      </text>
      <text
        x="680"
        y="150"
        text-anchor="middle"
        fill="#000000"
        font-size="18"
        class="element-text"
        @click="handleClick(3)"
      >
        {{ $t('hour_range', {s: 4, e: 8}) }}
      </text>

      <!-- Task 2 Box -->
      <rect
        x="810"
        y="75"
        width="140"
        height="100"
        rx="15"
        ry="15"
        :fill="currentStep === 4 ? '#e0e0e0' : '#ffffff'"
        stroke="#666666"
        stroke-width="2"
        class="workflow-element clickable"
        @click="handleClick(4)"
      />
      <text
        x="880"
        y="120"
        text-anchor="middle"
        fill="#000000"
        font-size="18"
        font-weight="bold"
        class="element-text"
        @click="handleClick(4)"
      >
        {{ $t('unfold') }}
      </text>
      <text
        x="880"
        y="150"
        text-anchor="middle"
        fill="#000000"
        font-size="16"
        class="element-text"
        @click="handleClick(4)"
      >
        {{ $t('consult_sla') }}
      </text>

      <!-- Decision 2 Diamond -->
      <polygon
        points="1080,75 1140,125 1080,175 1020,125"
        :fill="currentStep === 5 ? '#e0e0e0' : '#ffffff'"
        stroke="#666666"
        stroke-width="2"
        class="workflow-element clickable"
        @click="handleClick(5)"
      />
      <text
        x="1080"
        y="120"
        text-anchor="middle"
        fill="#000000"
        font-size="20"
        font-weight="bold"
        class="element-text"
        @click="handleClick(5)"
      >
        {{ $t('approval') }}
      </text>
      <text
        x="1080"
        y="150"
        text-anchor="middle"
        fill="#000000"
        font-size="18"
        class="element-text"
        @click="handleClick(5)"
      >
        {{ $t('hour_range', {s: 4, e: 8}) }}
      </text>

      <!-- End Circle -->
      <circle
        cx="1300"
        cy="125"
        r="25"
        :fill="currentStep === 6 ? '#e0e0e0' : '#ffffff'"
        stroke="#666666"
        stroke-width="2"
        class="workflow-element clickable"
        @click="handleClick(6)"
      />
      <text
        x="1300"
        y="180"
        text-anchor="middle"
        fill="#000000"
        font-size="22"
        font-weight="bold"
        class="element-text"
        @click="handleClick(6)"
      >
        {{ $t('end') }}
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'JobCreationDiagram',

  props: {
    currentStep: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      diagramWidth: 0,
      diagramHeight: 0,
      selectedStep: 0,
      stepPositions: {
        begin: { x: 80, y: 125 },
        initial: { x: 280, y: 125 },
        square1: { x: 480, y: 125 },
        decision1: { x: 680, y: 125 },
        square2: { x: 880, y: 125 },
        decision2: { x: 1080, y: 125 },
        end: { x: 1300, y: 125 }
      },
      stepDetails: {
        begin: {
          title: 'Job Initialization',
          description: 'Start the job workflow process. Initialize all required resources and validate prerequisites.'
        },
        initial: {
          title: 'Initial Setup',
          description: 'Perform initial configuration and prepare the workspace for job execution.'
        },
        square1: {
          title: 'Task 1 - Setup',
          description: 'Configure job parameters, assign resources, and prepare the work environment.'
        },
        decision1: {
          title: 'Quality Check Point 1',
          description: 'Review setup completion and validate all configurations before proceeding.'
        },
        square2: {
          title: 'Task 2 - Finalization',
          description: 'Complete final processing steps and prepare deliverables for review.'
        },
        decision2: {
          title: 'Quality Check Point 2',
          description: 'Final review of deliverables and quality assurance before completion.'
        },
        end: {
          title: 'Job Completion',
          description: 'Finalize the job, archive results, and update status to completed.'
        }
      }
    }
  },

  mounted() {
    if(this.currentStep) {
      this.selectedStep = this.currentStep
    }
  },

  methods: {
    handleClick(step) {
      this.selectedStep = step
      this.$emit('step-clicked', this.selectedStep)
    },
  }
}
</script>

<style scoped>
.workflow-diagram {
  width: 100%;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.workflow-svg {
  width: 100%;
  height: auto;
  min-height: 50px;
  background: white;
}

.workflow-element {
  transition: all 0.3s ease;
}

.clickable {
  cursor: pointer;
}

.element-text {
  pointer-events: none;
  user-select: none;
}

.arrow {
  transition: stroke-width 0.3s ease;
}


.forward-arrow {
  stroke: #000000;
}

.backward-arrow {
  stroke: #000000;
}

.status-indicator {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.workflow-legend {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 15px;
  padding: 10px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.forward-arrow-color {
  background: #2196F3;
}

.backward-arrow-color {
  background: #FF9800;
}

.begin-color {
  background: #4CAF50;
}

.task-color {
  background: #2196F3;
}

.decision-color {
  background: #FF9800;
}

.step-details {
  margin-top: 15px;
  padding: 15px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  border-left: 4px solid #2196F3;
}

.step-details h4 {
  margin: 0 0 10px 0;
  color: #1976D2;
}

.step-details p {
  margin: 0 0 15px 0;
  color: #666;
  line-height: 1.4;
}

.step-actions {
  display: flex;
  gap: 10px;
}

/* Responsive design */
@media (max-width: 768px) {
  .workflow-legend {
    flex-direction: column;
    gap: 10px;
  }

  .workflow-svg {
    height: 150px;
  }
}
</style>
